/*
Copyright (c) 2022 COUNTRYSIDE STOVE & CHIMNEY, INC. - ALL RIGHTS RESERVED

UNAUTHORIZED COPYING, MODIFICATION, OR DISTRIBUTION OF THIS SOFTWARE AND ASSOCIATED DOCUMENTATION FILES ("THE SOFTWARE"),
IN ANY MEDIUM IS STRICTLY PROHIBITED
PROPRIETARY AND CONFIDENTIAL
WRITTEN BY BRANDON SULLIVAN <info@empiredistributing.net>, March 2022
*/

import { Dimensions, StyleSheet, Platform } from 'react-native';
const entireScreenHeight = Dimensions.get('window').height;

/*
Device Orientation Changes:
Sets Scroll Enabled | True / False
If Portrait: Scroll Enabled = False
If Landscape: Scroll Enabled = True
*/

const isLandscape = () => {
  const dim = Dimensions.get('screen');
  return dim.height < dim.width;
};
let inputWidth;
let passwordIcon;
let imageHeight;
let verifyButtonMarginTop;
if (Platform.OS === 'web' && isLandscape()) {
 inputWidth = "30%";
 passwordIcon = "90%";
 imageHeight = entireScreenHeight / 3;
 verifyButtonMarginTop = 60;
}
else {
 inputWidth = "90%";
 passwordIcon = "85%";
 imageHeight = entireScreenHeight / 5;
 verifyButtonMarginTop = 10;
}

export default StyleSheet.create({
    container: {
            flex: 1,
            backgroundColor: 'black',
            justifyContent: 'center',
            alignItems: 'center',
            marginBottom: Platform.OS === 'web'? 0: 90,
        },
        termsContainer: {
        //flex: 1,
            position: 'absolute',
            bottom: 0,
            right: 0,
            left: 0,
        backgroundColor: 'black',

       },
    logo: {
        flex: 1,
        height: entireScreenHeight / 7,
        width: 400,
        margin: 20,
        resizeMode: 'contain',
    },
    input: {
        height: 48,
        borderRadius: 5,
        overflow: 'hidden',
        backgroundColor: 'white',
        marginTop: 10,
        marginBottom: 10,
        marginLeft: 30,
        marginRight: 30,
        paddingLeft: 16,
        width: inputWidth,
    },
    button: {
        backgroundColor: '#00000000',
        marginTop: verifyButtonMarginTop,
        height: 48,
        borderRadius: 5,
        alignItems: "center",
        justifyContent: 'center',
        width: 200,
        borderTopColor: '#cccccc',
        borderBottomColor: '#cccccc',
        borderLeftColor: '#cccccc',
        borderRightColor: '#cccccc',
        borderTopWidth: 1,
        borderBottomWidth: 1,
        borderLeftWidth: 1,
        borderRightWidth: 1,
        alignSelf: 'center'
    },
    buttonTitle: {
        color: 'white',
        fontSize: 16,
        fontWeight: "bold",
    },
       passwordContainer: {
       flexDirection: 'row',
        height: 48,
        borderRadius: 5,
        overflow: 'hidden',
        backgroundColor: 'white',
        marginTop: 10,
        marginBottom: 10,
        marginLeft: 30,
        marginRight: 30,
        paddingLeft: 16,
        width: inputWidth,
    },
      inputPassword: {
            width: passwordIcon,
        },
    passwordIcon: {
    padding: 14,
    },
    footerView: {
        flex: 1,
        alignItems: "center",
        marginTop: 20,
        marginBottom: 50,
    },
    footerText: {
        fontSize: 16,
        color: 'lightgrey',
        marginTop: 30,
    },
    footerLink: {
        color: 'red',
        fontWeight: "bold",
        fontSize: 16
    },
        appMessage: {
        padding: 10,
        color: 'white',
        fontSize: 18,
        alignSelf: 'center'
        },
    textIcon: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    paddingTop: 30,
    },
    iconPadding: {
    paddingRight: 20,
    },
    termsButtonContainer: {
    alignItems: 'center',
    backgroundColor: 'black'
    },
    termsButtonTextAccept: {
    color: 'white'
    },
    termsButtonTextDecline: {
    color: 'white',

    },
     registrationContainer: {
     marginTop: 35,
     alignItems: 'center',
     width: "100%",
     },
     actionButtonsContainer: {
     marginTop: 20,
     },

     sectionHeaderTitle: {
     fontWeight: 'bold',
     fontSize: 20,
     },
     sectionHeaderContainer: {
     flexDirection: 'row',
     alignItems: 'center',
     marginTop: 20,
     marginBottom: 10,
     marginLeft: 21,
     },
     actionInput: {
     width: inputWidth,
     },
     inputStyle: {
     color: 'black',
     },
     inputContainerStyle: {
     backgroundColor: 'white',
     borderRadius: 11/2,
     paddingLeft: 10,
     paddingRight: 10,
     },

    containerWebView: {
        flex: 1,
        marginBottom: 90,
    },
    navigation: {
        flex: 1,
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        width: '100%',
        backgroundColor: 'black',
        position: 'absolute',
        bottom: 0
    },
})